$(document).ready(function(){
// modal
 $(".product-single.product_single_block .thumbnails-wrapper ul li img.product-single__thumbnail-image").click(function(){
  var thumb_img = $(this).attr("img_src");
  $(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").attr("data-srcset", ''); 
  $(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").attr("srcset", ''); 
  $(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").attr("src", thumb_img); 
 
})

/// 
$(".product-single__photo-wrapper.js .product-single__photo img.feature-row__image.product-featured-img").click(function(){
  var main_img = $(this).attr("src");
  $("#main-img_modal").attr("src", main_img);
  $(".main_img_modal").show();
})

 

$(".controls i.fa.fa-close, .main_img_modal .modal_overlay").click(function(){
  $(".main_img_modal").hide();
})

  
})